import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import ChainedBackend from 'i18next-chained-backend';
import HttpApi from 'i18next-http-backend';
import resourcesToBackend from 'i18next-resources-to-backend';
import translationLocalEN from './locales/en/translation';
import { merge } from 'lodash';
import environment from './environment';
import { AppConstants } from './constants/AppConstants';

const currentLocale = navigator.language || 'en'; 
const loadCurrentLocaleTranslation = `${AppConstants.BASE_STORAGE_URL}/${
  environment.ENV_SOLUTION_NAME
}/i18n/translation_${currentLocale.trim()}.json`;

const resources: any = {
  en: {
    translation: translationLocalEN
  }
};

const cache: any = {};

const mergeTranslations = async (serverData: any, namespace: string, language: string) => {
  const languageKey = `${namespace}_${language}`;

  if (cache[languageKey]) {
    return cache[languageKey];
  }

  const mergedData = merge({}, resources[language]?.[namespace], serverData);

  cache[languageKey] = mergedData;

  return mergedData;
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .use(ChainedBackend)
  .init({
    fallbackLng: 'en',
    ns: ['translation'],
    defaultNS: 'translation',
    backend: {
      backends: [HttpApi, resourcesToBackend(resources)],
      backendOptions: [
        {
          loadPath: loadCurrentLocaleTranslation,
          parse: async (data: any, language: string, namespace: string) => {
            const serverData = JSON.parse(data);
            const mergedData = await mergeTranslations(serverData, namespace, language);
            return mergedData;
          }
        }
      ]
    },
    interpolation: {
      escapeValue: false, 
    },
    saveMissing: false,   
    react: {
      useSuspense: false, 
    },
    partialBundledLanguages: true,
    resources,
  });

export default i18n;
